import React, {FC} from 'react';
import styled from 'styled-components';

import {getMergedTicketIds} from '../../../../../../libs/inboxes/business/src/ticketing/conversation';
import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {StyledGridContentDiv, StyledIconDiv} from './conversationSummaryCommonStyles';
import {
  ConversationSummaryDetailsSubsection,
  StyledDetailsSubsectionListDiv,
} from './conversationSummaryDetailsSubsection';

/*
 * Props.
 */

interface ConversationSummaryMergedTicketIdsProps {
  conversation: ConversationModel;
}

/*
 * Styles.
 */

const StyledChannelsListDiv = styled(StyledDetailsSubsectionListDiv)`
  grid-row-gap: 9px;
`;

/*
 * Component.
 */

export const ConversationSummaryMergedTicketIds: FC<ConversationSummaryMergedTicketIdsProps> = (props) => {
  const {conversation} = props;
  const mergedTicketIds = getMergedTicketIds(conversation);

  if (mergedTicketIds.length === 0) {
    return null;
  }

  return (
    <ConversationSummaryDetailsSubsection
      title={<Trans id="conversation-summary-merged-ticket-ids">Merged ticket IDs</Trans>}
      content={<StyledChannelsListDiv>{mergedTicketIds.map(renderTicketId)}</StyledChannelsListDiv>}
    />
  );
};

function renderTicketId(ticketId: string) {
  return (
    <UserThemeConsumer key={ticketId}>
      {(theme) => (
        <>
          <StyledIconDiv>
            <Icon name="mergeFilledSmall" color={theme.greys.shade50} />
          </StyledIconDiv>
          <StyledGridContentDiv>{ticketId}</StyledGridContentDiv>
        </>
      )}
    </UserThemeConsumer>
  );
}
